import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getLogo, getWebsiteName} from '../../store/selectors';

const Logo = () => {
  const { t } = useTranslation();
  const websiteName = useSelector(getWebsiteName);
  const logo = useSelector(getLogo);

  return (
    <>
      <span className="logo">
        <img
          src={logo}
          className="logo__image"
          alt={websiteName || t('wrongWebsiteLogo')}
        />
      </span>
    </>
  );
};
export default Logo;
